import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
// import { getUser } from "../../../services/authService";
import TableColumnOrder from "../TableColumnOrder";
import { filter } from "lodash";
import Tooltips from "../../Custom Components/tooltip";
import DeleteModal from "../DeleteModal";
import { deleteAllContainerMasterData, 
  // deleteContainerMasterDataAggregate,
  //  deleteContainerMasterDataFiveM,
  //   deleteContainerMasterDataTractor
   } from "../../../services/ContainerMasterService";
import { toast } from "react-toastify";
import { getUser } from "../../../services/authService";
import FactoryOutCheckModal from "../FactoryOutCheckModal";
import { ErrorMsg } from "../../../utils/validator";

function ArrivalReportActionCenter({
  date,
  setDate,
  dataExportHandler,
  allColumns,
  getToggleHideAllColumnsProps,
  filteredUserAccessData,
  globalFilter,
  setGlobalFilter,
  selectedFlatRows,
  setNoDataState
}) {
  const [modalShow, setModalShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [deleteId, setDeleteId] = useState("")
	const [deleteIdAggregate, setDeleteIdAggregate] = useState("")
	const [deleteIdFiveM, setDeleteIdFiveM] = useState("")
  const [showFactoryOutModal, setFactoryOutModal] = useState(false);
  var allowToDownload = filter(filteredUserAccessData,{DownLoad:1}).length > 0
  var allowToDelete= filter(filteredUserAccessData,{Delete:1}).length > 0
  const deletePlan = async () => {
    if (selectedFlatRows) {
      let deleteList = "";
      let deleteListAggregate = "";
      let deleteListFiveM = "";
      const tractorFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "TRACTOR";
      });
      const aggregateFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "AGGREGATE";
      });
      const fiveMFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "5M";
      });
      tractorFilterData.length === 0
        ? setDeleteId("")
        : setDeleteId(deleteList);
      aggregateFilterData.length === 0
        ? setDeleteIdAggregate("")
        : setDeleteIdAggregate(deleteListAggregate);
      fiveMFilterData.length === 0
        ? setDeleteIdFiveM("")
        : setDeleteIdFiveM(deleteListFiveM);

      let err = [];
      for (let i = 0; i < tractorFilterData.length; i++) {
        if (tractorFilterData[i].original["Gate_Out_Date"] !== null) {
          err.push(tractorFilterData[i].original["Booking_Number"]);
        } else {
          deleteList += tractorFilterData[i].original["ContainerMasterId"];
          setDeleteId(deleteList);
        }
      }
      for (let i = 0; i < aggregateFilterData.length; i++) {
        if (aggregateFilterData[i].original["Gate_Out_Date"] !== null) {
          err.push(aggregateFilterData[i].original["Booking_Number"]);
        } else {
          deleteListAggregate +=
            aggregateFilterData[i].original["ContainerMasterId"];
          setDeleteIdAggregate(deleteListAggregate);
        }
      }
      for (let i = 0; i < fiveMFilterData.length; i++) {
      
        if (fiveMFilterData[i].original["Gate_Out_Date"] !== null) {
          err.push(fiveMFilterData[i].original["Booking_Number"]);
        
        } else {
         
          deleteListFiveM += fiveMFilterData[i].original["ContainerMasterId"];
          setDeleteIdFiveM(deleteListFiveM);
          
       
          
        }
      }

      if (err.length > 0) {
        setFactoryOutModal({
          status: true,
          msg: ErrorMsg(err)
        });
      } else {
   
        const payload = [
          {
            TractorId: deleteList,
            AggregateId: deleteListAggregate,
            FiveMId: deleteListFiveM,
            DataAvailable: "No",
            Deleted_By: getUser().uid,
          },
        ];
        try {
          const response = await deleteAllContainerMasterData(payload);
          setShowDeleteModal({ status: true, msg: response.data.Message });
        } catch (error) {
          toast.error(error.response.data.Message);
        }
      }
    }
  };

  return (
    <>
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          dataType="Arrival Report"
					label = "delete plan"
          date={date}
          selectedDeleteRows={selectedFlatRows}
          setNoDataState={setNoDataState}
        />
      )}
      {modalShow && (
        <TableColumnOrder
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
      {/* <FactoryOutCheckModal
          showModal={showFactoryOutModal}
          hide={() => setFactoryOutModal(false)}
          label="change Module"
       
          
          button="ok"
          setNoDataState={setNoDataState}
         
        /> */}
      <div className="flex-row-align-center">
        <Form.Control
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="hiden-inp"
          placeholder="search here.."
          style={{ width: "auto" }}
        />
        <div
          style={{
            display: "flex",
            width: "200px",
            alignItems: "center",
            marginLeft: "10px",
          }}
        >
          <strong>From-</strong>
          <Form.Control
            type="date"
            value={date.fromdate}
            onChange={(e) => {
              if(e.target.value <= date.todate){
                setDate({ ...date, fromdate: e.target.value })
              }else{
                setDate({ ...date, fromdate: date.fromdate })
                alert('From date should not greater than To date.')
              }
            }}
            name="fromDate"
          />
        </div>
        <div
          style={{
            display: "flex",
            width: "200px",
            alignItems: "center",
            marginLeft: "10px",
          }}
        >
          <strong>To-</strong>
          <Form.Control
            type="date"
            value={date.todate}
            onChange={(e) => {
              if(e.target.value >= date.fromdate){
                setDate({ ...date, todate: e.target.value })
              }else{
                setDate({ ...date, todate: date.todate })
                alert('To date should not lesser than From date.')
              }
            }}
            name="toDate"
          />
        </div>
        {allowToDownload && (
          <Tooltips content={"Download Report"} direction="down">
            <button
              className="tractorActionCenter__upload"
              onClick={() => dataExportHandler()}
            >
              <i className="bx bxs-download"></i>
            </button>
          </Tooltips>
        )}
        {allowToDelete && (
          <Tooltips content={"Delete"} direction="down">
            <button
              className="transporterActionCenter__delete"
              variant="danger"
              onClick={deletePlan}
              disabled={selectedFlatRows.length === 0}
              id = "arrivalBulkDelete"
              // disabled={loading}
            >
              <i class="bx bxs-trash"></i>
            </button>
          </Tooltips>
        )}
        <Tooltips content={"Column Filter"} direction="down">
          <button
            className="tableColumnFilter_btn "
            onClick={() => setModalShow(true)}
          >
            <i class="bx bx-columns tableColumnFilter"></i>
          </button>
        </Tooltips>
      </div>
    </>
  );
}

export default ArrivalReportActionCenter;
